import { render, staticRenderFns } from "./SubscribeScrollToTop.vue?vue&type=template&id=3d476fcc&scoped=true&"
import script from "./SubscribeScrollToTop.vue?vue&type=script&lang=js&"
export * from "./SubscribeScrollToTop.vue?vue&type=script&lang=js&"
import style0 from "./SubscribeScrollToTop.vue?vue&type=style&index=0&id=3d476fcc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d476fcc",
  null
  
)

export default component.exports